import React from "react"
import classes from "./AssessmentRow.module.css"
import { useSelector } from "react-redux";

const AssessmentRow = ({ asessment, currentAssessmentId, setCurrentAssessmentId }) => {
    const { direction } = useSelector((state) => state.translate);

    return (
        <>
            <div className={`${classes.AssessmentWarrper}  ${currentAssessmentId === asessment.id && classes.CurrentAssessment}`} onClick={() => setCurrentAssessmentId(asessment.id)}>
                <div className={`${classes.Assessment}`}>
                    <div className={classes.SlideWrap}>
                        <div className={classes.Slide}>{asessment.parentName}</div>
                        <div className={classes.SlideTulltip}>{asessment.parentName}</div>
                    </div>

                    <div className={classes.QuestionWrap}>
                        <div className={classes.Question}>{asessment.name}</div>
                        <div className={classes.QuestionTulltip}>{asessment.name}</div>
                    </div>

                    <div className={classes.Score}>{asessment.maxScore ? `${Math.round(asessment?.submissionAggregation?.scoreAverage * 100)}%` : '-'}</div>
                    <div className={classes.AnswewrdPercent}>{Math.round(asessment?.submissionAggregation?.submissionsPercentage * 100)}%</div>

                </div>
                {currentAssessmentId == asessment.id && <div className={`${classes[direction]} ${classes.TryAngle}`}></div>}
            </div>

        </>
    )
}
export default AssessmentRow